import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Mail, Users, Info, Download } from "lucide-react";

export default function AdminNewsletter() {
  const [data, setData] = useState({ items: [], total: 0 });
  useEffect(() => { api.get("/admin/subscribers").then((r) => setData(r.data)).catch(() => {}); }, []);

  const exportCsv = () => {
    const rows = [["email", "name", "subscribed_at"], ...data.items.map((s) => [s.email, s.name || "", s.created_at || ""])];
    const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
    const url = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    const a = document.createElement("a"); a.href = url; a.download = "subscribers.csv"; a.click();
  };

  return (
    <div className="max-w-4xl">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h1 className="text-2xl font-bold text-white">Newsletter</h1>
          <p className="text-sm text-white/50">Opt-in subscribers from the website footer.</p>
        </div>
        <button onClick={exportCsv} data-testid="export-subscribers" className="inline-flex items-center gap-2 px-4 py-2 rounded-full card-surface text-white text-sm font-semibold hover:bg-white/5"><Download size={15} /> Export CSV</button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-5">
        <div className="card-surface rounded-xl p-5"><Users size={18} className="text-[hsl(var(--primary))]" /><div className="mt-3 text-3xl font-bold font-head text-white">{data.total}</div><div className="text-xs text-white/50 mt-1">Total Subscribers</div></div>
      </div>

      <div className="flex items-start gap-2 p-3 rounded-lg bg-amber-500/10 border border-amber-500/20 text-sm text-white/70 mb-5">
        <Info size={16} className="text-amber-400 shrink-0 mt-0.5" />
        <span>Subscribers receive a transactional welcome email automatically on signup. For anti-phishing compliance, mass marketing "blasts" are not sent from the shared email domain — export the list to use a dedicated marketing provider if you need campaigns.</span>
      </div>

      <div className="card-surface rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-white/40 border-b border-white/10">
            <th className="p-4 font-semibold">Email</th><th className="p-4 font-semibold hidden md:table-cell">Name</th><th className="p-4 font-semibold hidden lg:table-cell">Subscribed</th>
          </tr></thead>
          <tbody>
            {data.items.map((s) => (
              <tr key={s.id} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02]">
                <td className="p-4 text-white/80"><span className="flex items-center gap-2"><Mail size={13} className="text-white/40" /> {s.email}</span></td>
                <td className="p-4 hidden md:table-cell text-white/60">{s.name || "—"}</td>
                <td className="p-4 hidden lg:table-cell text-white/50">{s.created_at ? new Date(s.created_at).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
            {data.items.length === 0 && <tr><td colSpan={3} className="p-10 text-center text-white/40">No subscribers yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
